import { HEADERS } from '@/dev'
import keys from '@/config/keys'

// Lowercased, exact-match hosts (no subdomains except netlify wildcard)
const SPECIAL_HOSTS = new Set([
	'uk.emma-live.com',
	'uk2.emma-live.com',
	'us.emma-live.com',
	'us2.emma-live.com',
	'dev2.emma-live.com',
	'99.emma-live.com',
	'staging.uk.emma-live.com',
	'astarauction.com',
	'blacktieauctions.org',
	'weareeventpal.com',
	'echelonfundraising.com',
	'staging.uk2.emma-live.com',
	'whitelabel.emma.bbww.dev',
	'superstars.auction',
	'app.smartgalas.com',
])

export const buildEmmaDomainReferer = (href = window.location.href) => {
	const _domain_referer = HEADERS[keys.HEADERS.DOMAIN_REFERER]
	if (_domain_referer) return _domain_referer

	// Fallback if window/location is weird
	if (!href) return ''

	const url = new URL(href)
	const hostname = url.hostname.toLowerCase()

	const isNetlify = hostname.endsWith('.netlify.app')
	const isWidgetElnk = hostname.endsWith('.widget.elnk.co')
	const isSpecial = isNetlify || isWidgetElnk || SPECIAL_HOSTS.has(hostname)

	// For special hosts (incl. *.netlify.app): send origin + first path segment (if any)
	if (isSpecial) {
		// pathname like "/foo/bar" -> firstSeg = "foo"
		const firstSeg = url.pathname.split('/').filter(Boolean)[0]
		return firstSeg ? `${url.origin}/${firstSeg}` : url.origin
	}

	// For others (custom domains): send only the host (origin)
	return url.origin
}
